export default "__VITE_ASSET__Dsgh09Iy__"